import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import {
  Table, TableBody, TableCell, TableHead, TableRow, Box, Typography, Button,
} from '@material-ui/core';
import {
  PROCESS_STATUS,
  COUNT_DISP_STATUS,
  ERRORFILE_DISP_STATUS,
  DATE_TIME_FORMAT,
  CHAR_CODE_MATCHING,
  EXCLUDE_DISP_STATUS,
} from '../../../common/const';
import {
  setSystemLodingFLg,
} from '../../actions/CommonAction';
import {
  setDispTab,
  updateExecute,
  errorFileDownloadExecute,
  searchUploadJobList,
  filterJobList,
} from '../../actions/UploadAction';
import styles from './UploadResultComponent.module.css';
import MyIcon from '../common/MyIcon';

class UploadResultComponent extends Component {
  /**
 * エラーダウンロード
 */
  onclickErrorDownLoad = async (fileId, fileName) => {
    const {
      selectJob,
      errorFileDownloadExecuteAct,
      setSystemLodingFLgAct,
    } = this.props;

    setSystemLodingFLgAct(true);
    // ファイルダウンロード
    await errorFileDownloadExecuteAct(selectJob.seq_id, selectJob.status, fileId, fileName);
    setSystemLodingFLgAct(false);
  }

  render() {
    const { selectJob } = this.props;

    // 処理開始日
    const processStartDate = selectJob.create_datetime
      && moment(
        selectJob.create_datetime, DATE_TIME_FORMAT.DATE_TIME_FULL,
      ).format(DATE_TIME_FORMAT.DATE_TIME_FULL);
    // 処理終了日(ステータスが処理中か受付中以外の場合表示)
    const processEndDate = [PROCESS_STATUS.PROCESSING, PROCESS_STATUS.ACCEPTING]
      .includes(selectJob.status)
      && selectJob.update_datetime
      ? ''
      : moment(
        selectJob.update_datetime, DATE_TIME_FORMAT.DATE_TIME_FULL,
      ).format(DATE_TIME_FORMAT.DATE_TIME_FULL);
    // 文字コード
    let charCode = '';
    if (selectJob.char_code === CHAR_CODE_MATCHING.SJIS) {
      charCode = 'Shift-JIS';
    } else if (selectJob.char_code === CHAR_CODE_MATCHING.UTF8) {
      charCode = 'UTF-8';
    }
    // ステータス名
    const statusName = selectJob.status_name;

    // アップロードファイル一覧
    const fileList = selectJob.uploadfile_list;

    // 取引情報ファイル名
    const additionalItemsFileName = fileList[0] && fileList[0].file_name;

    // 取引情報カウント
    const additionalItemsFileCount = COUNT_DISP_STATUS.includes(selectJob.status)
      && fileList[0]
      && fileList[0].process_count !== undefined
      && fileList[0].process_count !== null
      && fileList[0].process_count !== ''
      && fileList[0].read_count !== undefined
      && fileList[0].read_count !== null
      && fileList[0].read_count !== ''
      && !Number.isNaN(Number(fileList[0].process_count))
      && !Number.isNaN(Number(fileList[0].read_count))
      ? `${Number(fileList[0].process_count).toLocaleString()}/${Number(fileList[0].read_count).toLocaleString()}件`
      : '';

    // エラーファイルダウンロード
    const additionalItemsErrfileName = ERRORFILE_DISP_STATUS.includes(selectJob.status)
      && fileList[0]
      && fileList[0].errfile_name
      ? fileList[0].errfile_name
      : '';

    // 除外レコードダウンロード
    const excludeErrfileName = EXCLUDE_DISP_STATUS.includes(selectJob.status)
      && fileList[0].process_count !== undefined
      && fileList[0].process_count !== null
      && fileList[0].read_count !== undefined
      && fileList[0].read_count !== null
      && fileList[0].process_count !== fileList[0].read_count
      ? fileList[0].errfile_name : '';

    // ファイルID
    const additionalItemsFileId = fileList[0] && fileList[0].file_id;

    return (
      <Box className={`${styles.uploadresults}`}>
        <Box display="flex" alignItems="center" flexDirection="column" className={`${styles.uploadresultsframe}`}>
          <Table className={`${styles.uploadresultsfield}`}>
            <TableHead className={`${styles.header}`}>
              <TableRow>
                <TableCell colSpan={2} className={`${styles.headerTitle} ${styles.topRadius}`}>取引情報アップロード結果</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow className={`${styles.row}`}>
                <TableCell className={`${styles.rowTitle}`}>
                  <Typography>処理開始日時</Typography>
                </TableCell>
                <TableCell className={`${styles.itemCell}`}>
                  <Box display="flex" alignItems="center">
                    <Typography className={`${styles.item}`}>{processStartDate}</Typography>
                  </Box>
                </TableCell>
              </TableRow>
              <TableRow className={`${styles.row}`}>
                <TableCell className={`${styles.rowTitle}`}>
                  <Typography>処理終了日時</Typography>
                </TableCell>
                <TableCell className={`${styles.itemCell}`}>
                  <Box display="flex" alignItems="center">
                    <Typography className={`${styles.item}`}>{processEndDate}</Typography>
                  </Box>
                </TableCell>
              </TableRow>
              <TableRow className={`${styles.row}`}>
                <TableCell className={`${styles.rowTitle}`}>
                  <Typography>文字コード</Typography>
                </TableCell>
                <TableCell className={`${styles.itemCell}`}>
                  <Box display="flex" alignItems="center">
                    <Typography className={`${styles.item}`}>{charCode}</Typography>
                  </Box>
                </TableCell>
              </TableRow>
              <TableRow className={`${styles.row}`}>
                <TableCell className={`${styles.rowTitle} ${styles.leftBottomRadius}`}>
                  <Typography>状態</Typography>
                </TableCell>
                <TableCell className={`${styles.itemCell} ${styles.rightBottomRadius}`}>
                  <Box display="flex" alignItems="center">
                    <Typography className={`${styles.item}`}>{statusName}</Typography>
                  </Box>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
          <Table className={`${styles.uploadresultsfield}`}>
            <TableHead className={`${styles.header}`}>
              <TableRow>
                <TableCell colSpan={2} className={`${styles.headerTitle} ${styles.topRadius}`}>設定ファイル</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {additionalItemsErrfileName !== null
                && additionalItemsErrfileName !== ''
                && (
                  <TableRow className={`${styles.row}`}>
                    <TableCell colSpan={2} className={`${styles.itemCell} ${styles.commentCell}`}>
                      <Typography className={`${styles.comment}`}>※ダウンロードファイルはアップロード時に指定した文字コードになります。</Typography>
                    </TableCell>
                  </TableRow>
                )}
              {excludeErrfileName !== null
                && excludeErrfileName !== ''
                && (
                  <TableRow className={`${styles.row}`}>
                    <TableCell colSpan={2} className={`${styles.itemCell} ${styles.commentCell}`}>
                      <Typography className={`${styles.comment}`}>※公開企業に存在しないため除外されたレコードがあります。除外レコードはファイルをダウンロードしてご確認ください。</Typography>
                    </TableCell>
                  </TableRow>
                )}
              <TableRow className={additionalItemsErrfileName || excludeErrfileName ? `${styles.rowBtn}` : `${styles.row}`}>
                <TableCell className={`${styles.rowTitle} ${styles.leftBottomRadius}`}>
                  <Typography>取引情報</Typography>
                </TableCell>
                <TableCell className={`${styles.itemCell} ${styles.rightBottomRadius}`}>
                  <Box display="flex" alignItems="center">
                    <Typography className={`${styles.filename}`}>{additionalItemsFileName}</Typography>
                    {additionalItemsFileCount && (
                      <Typography className={`${styles.count}`}>{additionalItemsFileCount}</Typography>
                    )}
                    {additionalItemsErrfileName && (
                      <Box className={`${styles.errordownload}`}>
                        <Button
                          variant="contained"
                          color="secondary"
                          startIcon={<MyIcon className={`${styles.downloadIcon}`} type="download" />}
                          className={`${styles.btnSize}`}
                          onClick={
                            () => this.onclickErrorDownLoad(
                              additionalItemsFileId,
                              additionalItemsErrfileName,
                            )
                          }
                        >
                          エラーダウンロード
                        </Button>
                      </Box>
                    )}
                    {excludeErrfileName && (
                      <Box className={`${styles.errordownload}`}>
                        <Button
                          variant="contained"
                          startIcon={<MyIcon className={`${styles.downloadIcon} ${styles.excludeErrDownloadIcon}`} type="download" />}
                          className={`${styles.btnSize} addAll`}
                          onClick={
                            () => this.onclickErrorDownLoad(
                              additionalItemsFileId,
                              excludeErrfileName,
                            )
                          }
                        >
                          除外レコード
                        </Button>
                      </Box>
                    )}
                  </Box>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Box>
      </Box>
    );
  }
}

export default connect(
  (state) => ({
    selectJob: state.upload.selectJob,
  }),
  (dispatch) => ({
    setSystemLodingFLgAct: (bool) => dispatch(setSystemLodingFLg(bool)),
    setDispTabAct: (str) => dispatch(setDispTab(str)),
    updateExecuteAct: () => dispatch(updateExecute()),
    errorFileDownloadExecuteAct: (seqId, status, fileId, fileName) => dispatch(
      errorFileDownloadExecute(seqId, status, fileId, fileName),
    ),
    searchUploadJobListAct: (excutionDate) => dispatch(searchUploadJobList(excutionDate)),
    filterJobListAct: () => dispatch(filterJobList()),
  }),
)(UploadResultComponent);
